/*!
 * Copyright 2021 Cognite AS
 */

import defaultLog from './src/Log';
const Log = defaultLog.default;
export { Log };
